<input
  #siteLogoInput
  id="siteLogoInput"
  class="d-none"
  type="file"
  accept="image/*"
  (change)="handleSiteLogoInput($event.target)"
/>
<div id="siteDetail" class="pt-2 pt-lg-0 pe-lg-3">
  <div class="details-card mb-4 py-2">
    <div class="row row-cols-1 row-cols-lg-2 mb-lg-3">
      <div class="col-lg-8">
        <div class="col row row-cols-2">
          <div class="col-12 col-lg-9">
            <div class="d-flex align-items-top flex-column flex-lg-row">
              <div class="flex-grow-1">
                <dl id="siteName">
                  <div class="d-flex align-items-center">
                    <div
                      class="fs-4 pe-2 d-flex align-items-center mb-1 gap-3"
                      id="editSiteName"
                    >
                      {{ siteDetailData?.company_name }}

                      @if (isAdmin) {
                        <div class="d-flex flex-wrap gap-2">
                          <span
                            class="ms-3 edit-button"
                            (click)="editSite(siteDetailData)"
                          ></span>

                          @if (siteDetailData?.id) {
                            <div class="d-flex">
                              <span
                                class="ms-3 del-button"
                                [ngClass]="
                                  siteDetailData?.site_stats?.active_jobs_exists
                                    ? 'disabled-button'
                                    : ''
                                "
                                (click)="
                                  siteDetailData?.site_stats?.active_jobs_exists
                                    ? ''
                                    : deleteSite(siteDetailData)
                                "
                              ></span>
                              @if (
                                siteDetailData?.site_stats?.active_jobs_exists
                              ) {
                                <span
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  data-bs-title="Unable to delete, you have active tasks and/or jobs for this site."
                                >
                                  <i
                                    class="fa-solid fa-circle-info text-secondary opacity-75 small"
                                  ></i>
                                </span>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <dd id="editSiteAddress" class="d-flex align-items-center">
                    {{ siteDetailData?.address?.full_address }}
                    @if (isAdmin) {
                      <span
                        class="ms-3 edit-button"
                        (click)="isAdmin ? editSite(siteDetailData, false) : ''"
                      ></span>
                    }
                  </dd>
                </dl>
              </div>
              <div>
                <dl id="siteClient">
                  <div class="d-flex align-items-top flex-column">
                    <div>
                      <dt>Client</dt>

                      <dd class="d-flex align-items-center">
                        {{ siteDetailData?.company?.company_name }}
                        @if (isAdmin) {
                          <span
                            class="ms-3 me-2 edit-button"
                            (click)="
                              isAdmin
                                ? openSiteClientChangeTemplate(changeClientRef)
                                : ''
                            "
                          ></span>
                        }
                        @if (isAdmin || isDispatchUser) {
                          <span
                            class="ms-1 me-2 view-button"
                            (click)="redirectToClientPage()"
                          ></span>
                        }
                      </dd>
                    </div>
                  </div>
                </dl>
              </div>
            </div>

            <!--priority site section-->
            <!--https://app.shortcut.com/sendem/story/12805/priority-sites-->

            @if (isAdmin) {
              <dl>
                <div class="d-flex align-items-center fs-6 text-danger mt-2">
                  <input
                    type="checkbox"
                    id="prioritySiteSelection"
                    [checked]="
                      siteDetailData?.additional_info?.priority_info?.notes
                    "
                    (change)="openTemplate(prioritySiteMessageTemplate, $event)"
                  /><label
                    for="prioritySiteSelection"
                    class="ms-1"
                    role="button"
                    ><span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-title="Show an important message for alarm responses"
                    >
                      Priority Alarm Site</span
                    >
                  </label>
                  @if (siteDetailData?.additional_info?.priority_info?.notes) {
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-title="Show an important message for alarm responses"
                    >
                      <i class="ms-2 fa-solid fa-circle-info text-body"></i>
                    </span>
                  }
                </div>

                @if (siteDetailData?.additional_info?.priority_info?.notes) {
                  <div class="overflow-25vh">
                    <div
                      class="gt-multi-line link-edit fw-normal"
                      (click)="openTemplate(prioritySiteMessageTemplate)"
                    >
                      {{
                        siteDetailData?.additional_info?.priority_info?.notes
                      }}
                    </div>
                  </div>
                }
              </dl>
            }

            <dl id="siteAddress" class="d-none">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Address</dt>

                  <dd id="editSiteAddress" class="d-flex align-items-center">
                    {{ siteDetailData?.address?.full_address }}
                    @if (isAdmin) {
                      <span
                        class="ms-3 edit-button"
                        (click)="isAdmin ? editSite(siteDetailData, false) : ''"
                      ></span>
                    }
                  </dd>
                </div>
              </div>
            </dl>

            @if (siteDetailData?.id && isAdmin) {
              <dl>
                <gtapp-site-preferred-users
                  [onSiteDataInput]="siteDetailData"
                ></gtapp-site-preferred-users>
              </dl>
            }

            @if (isAdmin) {
              <div>
                <dl>
                  @if (
                    siteDetailData?.preferred_monitoring_company?.company_name
                  ) {
                    <dt>Primary Monitoring Company</dt>
                  }
                  <dd class="gt-multi-line d-flex align-items-center">
                    @if (
                      siteDetailData?.preferred_monitoring_company?.company_name
                    ) {
                      {{
                        siteDetailData?.preferred_monitoring_company
                          ?.company_name
                      }}
                      <span
                        class="ms-3 edit-button"
                        (click)="openMonitoringCompanyTemplate()"
                      ></span>
                    } @else {
                      <button
                        class="btn btn-sm btn-outline-secondary align-items-center"
                        (click)="openMonitoringCompanyTemplate()"
                      >
                        Primary Monitoring Company
                      </button>
                    }
                  </dd>
                </dl>
              </div>
            }

            @if (isAdmin) {
              <div>
                <dl>
                  @if (siteDetailData?.sub_biller?.company_name) {
                    <dt>Sub Biller</dt>
                  }
                  <dd class="gt-multi-line d-flex align-items-center">
                    @if (siteDetailData?.sub_biller?.company_name) {
                      {{ siteDetailData?.sub_biller?.company_name }}

                      <span
                        class="ms-3 edit-button"
                        (click)="openSubBillerTemplate()"
                      ></span>
                    } @else {
                      <button
                        (click)="openSubBillerTemplate()"
                        class="btn btn-sm btn-secondary align-items-center"
                      >
                        Add Sub Biller
                      </button>
                    }
                  </dd>
                </dl>
              </div>
            }
          </div>
          @if (isAdmin) {
            <div class="col-12 col-lg-3 mb-4 px-4 px-lg-2">
              <div class="d-flex gap-3 flex-lg-column flex-wrap">
                <div class="flex-grow-1">
                  <button
                    class="w-100 btn fw-normal"
                    [ngClass]="
                      siteDetailData?.site_stats?.job_exists
                        ? 'btn-warning'
                        : 'btn-outline-warning'
                    "
                    (click)="openJobView()"
                  >
                    <i class="fa-solid fa-bell"></i>
                    {{
                      siteDetailData?.site_stats?.job_exists
                        ? "Responses"
                        : "Add Response"
                    }}
                  </button>
                </div>
                <div class="flex-grow-1">
                  <button
                    class="w-100 btn fw-normal"
                    [ngClass]="
                      siteDetailData?.site_stats?.checkpoint_exists
                        ? 'btn-primary'
                        : 'btn-outline-primary'
                    "
                    (click)="openCPView()"
                  >
                    <i class="fa-solid fa-location-dot"></i>
                    {{
                      siteDetailData?.site_stats?.checkpoint_exists
                        ? "Checkpoints"
                        : "Add Checkpoint"
                    }}
                  </button>
                </div>

                @if (
                  siteDetailData?.site_stats?.report_exists ||
                  siteReportUsers?.length ||
                  patrolReportSchedules?.length
                ) {
                  <div class="flex-grow-1">
                    <button
                      class="w-100 btn fw-normal btn-success"
                      (click)="openReportView()"
                    >
                      <i class="fa-solid fa-file-lines"></i>
                      Report Setup
                    </button>
                  </div>
                }
                @if (
                  siteDetailData?.site_stats?.report_exists ||
                  siteDetailData?.site_stats?.job_exists
                ) {
                  <div class="flex-grow-1">
                    <button
                      class="w-100 btn fw-normal btn-secondary"
                      (click)="openEventLog()"
                    >
                      <i class="fa-solid fa-book"></i>
                      Updates
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="col d-lg-none mb-4">
          <gtapp-map-leaflet
            [latLon]="{
              lat: siteDetailData?.address?.latitude,
              lon: siteDetailData?.address?.longitude,
            }"
            [mapId]="'siteLocation'"
          ></gtapp-map-leaflet>
        </div>

        @if (isAdmin || isDispatchUser || siteDetailData?.information?.trim()) {
          <div>
            <!--the outer div is necessary for correct padding and matching other div dls-->
            <dl id="siteInformation">
              <dt>Site Information</dt>
              <dd class="gt-multi-line d-flex align-items-center">
                @if (siteDetailData?.information?.trim()) {
                  {{ siteDetailData?.information }}
                  @if (isAdmin || isDispatchUser) {
                    <span
                      class="ms-3 edit-button"
                      (click)="openInformationTemplate(siteInfoTemplate)"
                    ></span>
                  }
                } @else if (isAdmin || isDispatchUser) {
                  <button
                    class="btn btn-sm btn-secondary align-items-center"
                    (click)="openInformationTemplate(siteInfoTemplate)"
                  >
                    <i class="fa-solid fa-plus"></i>
                  </button>
                }
              </dd>
            </dl>
          </div>
        }

        @if (isAdmin) {
          <div>
            <!--the outer div is necessary for correct padding and matching other div dls-->
            <dl class="" id="siteManagerNotes">
              <dt class="text-danger fw-semibold">
                Manager Notes
                <span
                  class="me-3"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title="These notes are only visible to managers"
                >
                  <i class="fa-solid fa-circle-info text-secondary"></i>
                </span>
              </dt>

              <dd class="gt-multi-line" id="editSiteManagerNotes">
                @if (siteDetailData?.manager_notes?.trim()) {
                  <span class="text-danger fw-normal">
                    {{ siteDetailData?.manager_notes }}
                  </span>
                  <span
                    class="ms-3 edit-button"
                    (click)="openManagerInfoTemplate(requestManagerRef)"
                  ></span>
                } @else {
                  <button
                    class="btn btn-sm btn-outline-secondary align-items-center"
                    (click)="openManagerInfoTemplate(requestManagerRef)"
                  >
                    Add Manager Notes
                  </button>
                }
              </dd>
            </dl>
          </div>
        }

        <div class="row row-cols-1 row-cols-lg-2">
          @if (isAdmin || isDispatchUser || selectedSiteFiles?.length) {
            <div>
              <!--the outer div is necessary for correct padding and matching other div dls-->
              <dl id="siteFiles">
                <dt class="mb-2">
                  {{
                    isAdmin || isDispatchUser
                      ? "Site Files [" +
                        selectedSiteFiles?.length +
                        " / 20 Max]"
                      : "Site Files"
                  }}
                  @if (
                    (isAdmin || isDispatchUser) &&
                    selectedSiteFiles?.length < 20
                  ) {
                    <span
                      id="editSiteFiles"
                      class="ms-3 add-button"
                      (click)="openFileUploadTemplate(uploadRef)"
                    ></span>
                  }
                </dt>
                <dd class="d-flex flex-wrap gap-2 mb-3 overflow-45vh">
                  @for (file of selectedSiteFiles; track file; let i = $index) {
                    <div>
                      <div
                        class="d-flex fw-semibold text-primary gap-3 border rounded p-2"
                      >
                        <div (click)="onOpenFile(file)" role="button">
                          <span class="badge bg-primary me-2">{{
                            file?.extension
                          }}</span>
                          {{ file?.description }}
                        </div>
                        @if (isAdmin || isDispatchUser) {
                          <div
                            class="d-flex align-items-center me-2"
                            (click)="deleteFile(file)"
                          >
                            <i class="fa-solid fa-circle-minus text-danger"></i>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </dd>
                @if (
                  (isAdmin || isDispatchUser) && selectedSiteFiles?.length < 20
                ) {
                  <div
                    id="editSiteFiles"
                    class="rounded border shadow p-2 mb-2 text-center hover d-none"
                    role="button"
                    (click)="openFileUploadTemplate(uploadRef)"
                  >
                    <i class="fa-solid fa-plus"></i>
                  </div>
                }
              </dl>
            </div>
          }
          @if (siteDetailData?.id) {
            <gtapp-site-keys [selectedSite]="siteDetailData"></gtapp-site-keys>
          }
        </div>
      </div>

      <div class="col-lg-4 d-none d-lg-block">
        <gtapp-map-leaflet
          [latLon]="{
            lat: siteDetailData?.address?.latitude,
            lon: siteDetailData?.address?.longitude,
          }"
          [mapId]="'siteLocationLargeView'"
        ></gtapp-map-leaflet>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-md-3">
      @if (isAdmin) {
        <div>
          <dl id="sitePatrolReports">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Scheduled Patrol Route Reports</dt>
              </div>
              <div class="d-flex align-items-center">
                <span
                  (click)="openSchedulerTemplate()"
                  role="button"
                  id="editSitePatrolReports"
                  class="edit-button"
                >
                  <span id="edit-button-placeholder d-none"></span>
                </span>
              </div>
            </div>
            <dd #pc id="pc">
              @if (patrolReportSchedules?.length < 1) {
                <div class="alert alert-warning mt-2">
                  No one is receiving patrol reports.
                </div>
              }
              @if (patrolReportSchedules.length > 0) {
                <div class="small text-secondary">
                  <em>Reports for site updates will be sent to:</em>
                </div>
              }
              <table class="table table-hover">
                <tbody>
                  @for (schedule of patrolReportSchedules; track schedule) {
                    <tr
                      class="cursor-pointer"
                      (click)="openSchedulerTemplate(schedule)"
                    >
                      <td>
                        <div class="d-flex">
                          <div class="d-flex align-items-center me-3">
                            <i class="fa-solid fa-calendar-days fa-2x"></i>
                          </div>
                          <div class="flex-grow-1">
                            <div>{{ schedule?.name }}</div>
                            <div class="small-font">
                              {{ schedule?.schedule?.repeat_type | titlecase }}
                              &#64;
                              {{ schedule?.mail_time }}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </dd>
          </dl>
        </div>
      }
      @if (isAdmin) {
        <div>
          <dl id="siteJobReports">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <dt>Report Recipients</dt>
              </div>
              <div class="d-flex align-items-center">
                <span
                  (click)="openJobReportContactTemplate()"
                  role="button"
                  id="editSiteJobReports"
                  class="edit-button"
                >
                  <span id="edit-button-placeholder d-none"></span>
                </span>
              </div>
            </div>
            <dd #jc id="jc">
              @if (isAdmin || isDispatchUser) {
                @if (slicedSiteReportUsers.length > 0) {
                  <div class="col my-3 gap-2 d-flex align-items-center">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="auto_send_reports"
                      [checked]="siteDetailData?.auto_send_reports"
                      (change)="reportSendApproval()"
                    />
                    <label class="form-check-label" for="auto_send_reports">
                      Auto Send Reports</label
                    >
                    <span
                      class="ms-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="When checked, completed jobs will automatically send out a completed job report."
                    >
                      <i class="fa-solid fa-circle-info"></i>
                    </span>
                  </div>
                }
                @if (slicedSiteReportUsers.length > 0) {
                  @if (siteDetailData?.auto_send_reports) {
                    <div class="fw-bold text-primary mb-2">
                      Job Reports will be sent out automatically to the contacts
                      below
                    </div>
                  } @else {
                    <div class="fw-bold text-danger mb-2">
                      Job Reports must be sent out manually
                    </div>
                  }
                }
              }
              @if (slicedSiteReportUsers?.length < 1) {
                <div class="alert alert-danger mt-2">
                  No recipients configured for reports.
                </div>
              }
              <table class="table table-hover">
                <tbody>
                  @for (contact of slicedSiteReportUsers; track contact) {
                    <tr
                      class="cursor-pointer"
                      (click)="
                        openSiteContactTemplate(contact, siteDetailData, 'jc')
                      "
                    >
                      <td>
                        <div class="d-flex">
                          <div class="d-flex align-items-center me-3">
                            <i class="fa-solid fa-address-book fa-2x"></i>
                          </div>
                          <div class="flex-grow-1">
                            {{ contact?.full_name }}
                            <div class="small-font">
                              {{ contact?.email }}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <div>
                @if (siteReportUsers?.length > 3) {
                  <button
                    class="btn btn-primary btn-sm"
                    (click)="
                      slicedSiteReportUsers?.length > 3
                        ? (slicedSiteReportUsers = siteReportUsers?.slice(0, 3))
                        : (slicedSiteReportUsers = siteReportUsers)
                    "
                  >
                    {{
                      slicedSiteReportUsers?.length > 3
                        ? "View Less"
                        : "View All"
                    }}
                  </button>
                }
              </div>
            </dd>
          </dl>
        </div>
      }

      @if (isAdmin || isDispatchUser) {
        @if (siteDetailData?.site_logo_url) {
          <div>
            <dl>
              <dt>Letterhead Logo</dt>
              <div class="p-2">
                <img
                  id="clientLogo"
                  class="w-100 border bg-white"
                  src="{{ siteDetailData?.site_logo_url }}"
                  alt="Letterhead Logo"
                />
              </div>
              <div
                class="d-flex gap-2 flex-column flex-lg-row justify-content-center"
              >
                <button class="btn btn-sm btn-primary" (click)="openCamPopup()">
                  Update
                </button>
                <button
                  class="btn btn-sm btn-danger"
                  (click)="removeSiteLogo()"
                >
                  Delete
                </button>
              </div>
            </dl>
          </div>
        } @else {
          <div>
            <dl>
              <dt class="mb-2">
                <span
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Use a custom logo for reports for this site."
                >
                  Letterhead Logo
                </span>
                <span
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Use a custom logo for reports for this site."
                >
                  <i class="fa-solid fa-circle-info"></i>
                </span>
              </dt>
              <button
                class="btn btn-sm btn-outline-success"
                (click)="openCamPopup()"
              >
                Upload Logo
              </button>
            </dl>
          </div>
        }
      }

      <div>
        <dl id="siteContacts">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>Site Contacts</dt>
            </div>
            <div class="d-flex align-items-center">
              @if (isAdmin || isDispatchUser) {
                <span
                  (click)="openSiteLocationContactTemplate()"
                  role="button"
                  id="editSiteContacts"
                  class="edit-button"
                >
                  <span id="edit-button-placeholder d-none"></span>
                </span>
              }
            </div>
          </div>

          <dd>
            @if (!siteContactListTemp?.length) {
              <div class="alert alert-warning mt-2">
                No Contacts Have Been Added To This Site Yet
              </div>
            }
            @if (siteContactListTemp.length > 0) {
              <div class="small text-secondary">
                <em>Contacts assigned to the Site:</em>
              </div>
            }
            <table class="table table-hover">
              <tbody>
                @for (contact of siteContactListTemp; track contact) {
                  <tr
                    class="cursor-pointer"
                    (click)="
                      openSiteContactTemplate(contact, siteDetailData, 'lc')
                    "
                  >
                    <td>
                      <div class="d-flex">
                        <div class="d-flex align-items-center me-3">
                          <i class="fa-solid fa-address-book fa-2x"></i>
                        </div>
                        <div class="flex-grow-1">
                          {{ contact?.full_name }}
                          <div class="small-font">
                            {{ contact?.email }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </dd>
        </dl>
      </div>
    </div>
  </div>
  @if (largeView && isAdmin && siteHistory?.length) {
    <gtapp-gt-table
      id="siteHistory"
      [desktopTableUIData]="siteHistory"
      [desktopTableDetails]="userEventDetailsTableView"
      [otherParams]="{ paginationData: true }"
      (rowClick)="onTableRowClick($event)"
    ></gtapp-gt-table>
  }
  @if (selectedEvent) {
    <gtapp-selected-event-detail
      [selectedEvent]="selectedEvent"
    ></gtapp-selected-event-detail>
  }
</div>

<!-- Site Information POPOVER / DIALOG -->
<ng-template #siteInfoTemplate let-data let-siteInfoTemplateRef="dialogRef">
  <div class="dialog-box site-info-dialog card">
    <div class="card-header">
      Site Information
      <span class="float-end" (click)="siteInfoTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="row">
      <div class="col">
        <textarea
          class="form-control"
          placeholder="Information about the site."
          cols="20"
          [rows]="largeView ? 15 : 5"
          wrap="hard"
          type="text"
          [(ngModel)]="newInfromation"
        ></textarea>
      </div>
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="siteInfoTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-primary"
          [disabled]="newInfromation?.length && !newInfromation?.trim()"
          (click)="siteInfoTemplateRef.close(); updateSiteInformation()"
        >
          Update
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>

<!-- Client file Upload DIALOG -->
<ng-template #uploadRef let-data let-uploadRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Upload File
      <span
        class="float-end"
        (click)="
          uploadRef.close();
          fileUploadError = null;
          fileDescription = null;
          uploadFile = null
        "
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (fileUploadError) {
      <div class="mt-3">
        <div class="alert alert-warning">
          {{ fileUploadError }}
        </div>
      </div>
    }
    <div class="col mb-2">
      <button
        type="button"
        class="btn btn-md w-100"
        [ngClass]="uploadFile ? 'btn-outline-primary' : 'btn-primary'"
        (click)="selectFile()"
      >
        {{ uploadFile ? "Change File" : "Select File From Device" }}
      </button>

      <input
        #fileInput
        id="fileInput"
        style="display: none; cursor: pointer"
        type="file"
        accept=".pdf, .jpg, .jpeg, .png, .webp, .avif"
        (change)="handleFileInput($event)"
      />
    </div>

    <div class="form-floating mb-2">
      <input
        class="form-control"
        placeholder="File Description"
        required
        maxlength="30"
        type="text"
        [(ngModel)]="fileDescription"
      /><label>File Description</label>
    </div>

    <div class="row row-cols-2 g-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="
            uploadRef.close();
            fileUploadError = null;
            fileDescription = null;
            uploadFile = null
          "
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-lg w-100 btn-primary"
          [disabled]="!uploadFile || !fileDescription"
          (click)="onUploadFile(); uploadRef.close()"
        >
          Upload {{ uploadFile?.name }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Manager Notes POPOVER / DIALOG -->
<ng-template #requestManagerRef let-data let-requestManagerRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Manager Notes
      <span class="float-end" (click)="requestManagerRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="mb-2">These notes are only visible to managers.</div>
    <!-- Request Detail Section start-->
    <div class="row mb-2">
      <div class="col">
        <textarea
          class="form-control"
          placeholder="Notes about the site"
          cols="20"
          rows="5"
          wrap="hard"
          type="text"
          [(ngModel)]="newInfromation"
        ></textarea>
      </div>
    </div>

    <div class="row row-cols-2 g-2">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="requestManagerRef.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-lg w-100 btn-primary"
          [disabled]="newInfromation?.length && !newInfromation?.trim()"
          (click)="requestManagerRef.close(); updateSiteManagerNotes()"
        >
          Update
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>

<!-- Change Client DIALOG -->
<ng-template #changeClientRef let-data let-changeClientRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Assign to Another Client
      <span class="float-end" (click)="changeClientRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (!selectedClient?.id) {
      <div class="col">
        <gtapp-auto-complete
          [data]="clientLookupDataList"
          placeHolder="Client*"
          searchKeyword="company_name"
          [itemTemplate]="clientLookupTemplate"
          [addInitialKey]="isAdmin"
          (inputChanged)="onClientSearch($event)"
          [initialValue]="selectedClientName"
          (selected)="onClientSelect($event)"
          [inputId]="'clientId'"
          [enableCloseOption]="true"
          (fieldCleared)="editField('client')"
        >
        </gtapp-auto-complete>
        <ng-template #clientLookupTemplate let-item>
          @if (item?.key === 0) {
            <div>Add New Client</div>
          } @else {
            <div>
              <div>{{ item?.company_name }}</div>
              <div class="small-font text-secondary">
                {{ item?.address?.full_address }}
              </div>
            </div>
          }
        </ng-template>
      </div>
    }
    @if (selectedClient?.id) {
      <dl class="p-2">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <dt>Client</dt>
            <dd class="fw-semibold">
              {{ selectedClient?.company_name }}
            </dd>
          </div>
          <div>
            <span (click)="editField('client')">
              <i
                class="fa-solid fa-pen-to-square md-font-size text-secondary"
              ></i
            ></span>
          </div>
        </div>
      </dl>
      <div class="alert alert-danger">
        WARNING: Checkpoints, Incidents, and other data belonging to this site
        will also be assigned to
        <span class="fw-semibold">{{ selectedClient?.company_name }}</span
        >.
      </div>
      <div>
        <div class="text-center">
          To confirm, type {{ data?.randomNumber }} in the field:
        </div>
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]*"
          placeholder="{{ data?.randomNumber }}"
          [(ngModel)]="data.confirmNumber"
          class="form-control"
          autofocus
        />
      </div>
    }

    <div class="row row-cols-2 g-2 pt-3">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="changeClientRef.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-lg w-100 btn-success"
          [disabled]="
            data?.confirmNumber != data?.randomNumber || !selectedClient?.id
          "
          (click)="changeClientRef.close(); updateSiteClient()"
        >
          Confirm
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>

<!-- priority site message section -->
<ng-template
  #prioritySiteMessageTemplate
  let-data
  let-prioritySiteMessageTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Priority Alarm Response Site
      <span
        class="float-end"
        (click)="prioritySiteMessageTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="row mb-2">
      <div class="col">
        <div class="p-2 mb-3">
          This message will be shown when site is selected for an alarm
          response.
        </div>
        <div class="col form-group input-group">
          <textarea
            class="form-control"
            placeholder="Example: Penalty rates apply if guard is not onsite within 40 minutes."
            cols="20"
            rows="5"
            wrap="hard"
            type="text"
            autofocus
            id="priorityMessageField"
            [(ngModel)]="data.newValue"
          ></textarea>
          @if (data?.newValue) {
            <span
              class="input-group-text"
              (click)="data.newValue = ''; shiftFocus('priorityMessageField')"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </div>
    </div>

    <div class="row row-cols-2 g-2">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="prioritySiteMessageTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-lg w-100 btn-success"
          [disabled]="
            (data?.newValue?.length && !data?.newValue?.trim()) ||
            data?.newValue == data?.oldValue ||
            (!siteDetailData?.additional_info?.priority_info?.notes
              ? !data?.newValue?.trim()
              : false)
          "
          (click)="prioritySiteMessageTemplateRef.close(data)"
        >
          Submit
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>
